module.exports = __webpack_public_path__ + "static/media/versionnext-logo.abca9ec7.svg";